import React, { useState, useEffect } from 'react';
import { 
  CheckCircle2, 
  MapPin, 
  Leaf, 
  Coffee, 
  Mountain, 
  Droplets, 
  MessageCircle, 
  Phone, 
  Mail, 
  MessageSquare,
  X
} from 'lucide-react';


import SEO from '../components/SEO';
import api from '../services/api';



const VentaTonelada = () => {
  const [varieties, setVarieties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVariety, setSelectedVariety] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    country: '',
    phone: '',
    quantity: '1',
    quantityUnit: 'kg',
    quality: '',
    message: ''
  });

  useEffect(() => {
    cargarVariedades();
  }, []);

  const cargarVariedades = async () => {
    try {
      setLoading(true);
      // Conexión real a tu backend
      const response = await api.get('/cafe-verde');
      
      if (response.data && response.data.length > 0) {
        const variedadesMapeadas = response.data.map(item => ({
          id: item.id,
          name: item.nombre,
          origin: item.origen || 'Puebla, México',
          especie: item.especie || 'Arábica',
          altitude: item.altitud || '700 - 1,300 msnm',
          profile: item.perfil_taza || 'Por definir',
          humedad: item.puntaje || item.humedad || 'No aplica',
          stock: item.stock_kg || 100,
          price: 0,
          descripcion: item.descripcion || ''
        }));
        setVarieties(variedadesMapeadas);
      } else {
        setVarieties([]);
      }
    } catch (error) {
      console.error('Error cargando variedades:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const cantidadTexto = formData.quantityUnit === 'ton' 
      ? `${formData.quantity} tonelada(s)` 
      : `${formData.quantity} kg`;
    
    const mensaje = `Hola ${formData.name}, hemos recibido tu solicitud por ${cantidadTexto} de variedad ${formData.quality}. Un asesor se pondrá en contacto contigo al ${formData.phone} o vía email a ${formData.email} en menos de 24 horas.`;
    
    setModalMessage(mensaje);
    setShowModal(true);
  };

  const openWhatsApp = (variedad) => {
    const mensaje = `Hola, me interesa información sobre Café Verde: *${variedad.name}*\n\n` +
      `📍 *Origen:* ${variedad.origin}\n` +
      `🌱 *Especie:* ${variedad.especie}\n` +
      `☕ *Taza/Perfil:* ${variedad.profile}\n` +
      `📊 *Altitud:* ${variedad.altitude}\n` +
      `💧 *Humedad/Puntaje:* ${variedad.humedad}\n\n` +
      `¿Podrían darme más información sobre disponibilidad y precios?`;

    const whatsappUrl = `https://wa.me/527641057461?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // ESTILOS PUROS ENCAPSULADOS PARA ESTE COMPONENTE
  const internalStyles = `
    .vt-wrapper {
      font-family: system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      background-color: #fafaf9;
      color: #1c1917;
      line-height: 1.5;
      margin: 0;
      padding: 0;
    }
    
    /* Loader */
    .vt-loader { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #fafaf9; }
    .vt-spinner { width: 64px; height: 64px; border: 4px solid #a7f3d0; border-top-color: #059669; border-radius: 50%; animation: spin 1s linear infinite; }
    @keyframes spin { to { transform: rotate(360deg); } }
    .vt-loader p { margin-top: 16px; color: #57534e; font-weight: 500; font-size: 1.1rem; }

    /* Modal */
    .vt-modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 9999; padding: 20px; }
    .vt-modal { background: white; border-radius: 24px; padding: 40px; max-width: 450px; width: 100%; position: relative; box-shadow: 0 25px 50px rgba(0,0,0,0.25); text-align: center; animation: vtZoom 0.3s ease-out; }
    @keyframes vtZoom { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
    .vt-modal-close { position: absolute; top: 20px; right: 20px; background: none; border: none; cursor: pointer; color: #a8a29e; padding: 8px; border-radius: 50%; transition: background 0.3s; }
    .vt-modal-close:hover { background: #f5f5f4; color: #44403c; }
    .vt-modal-icon { width: 80px; height: 80px; background: #d1fae5; color: #059669; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px auto; }
    .vt-modal h3 { font-size: 1.5rem; margin: 0 0 12px 0; color: #1c1917; }
    .vt-modal p { color: #57534e; margin: 0 0 32px 0; line-height: 1.6; }

    /* Hero */
    .vt-hero { position: relative; height: 70vh; min-height: 500px; max-height: 800px; display: flex; align-items: center; justify-content: center; background: #1c1917; overflow: hidden; text-align: center; color: white; padding: 0 20px; }
    .vt-hero-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; opacity: 0.4; mix-blend-mode: overlay; }
    .vt-hero-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(to top, rgba(28,25,23,1) 0%, rgba(28,25,23,0.4) 50%, transparent 100%); }
    .vt-hero-content { position: relative; z-index: 10; max-width: 900px; margin-top: 64px; }
    .vt-badge { display: inline-block; padding: 6px 20px; background: rgba(16, 185, 129, 0.2); color: #6ee7b7; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; border-radius: 50px; margin-bottom: 24px; font-size: 14px; border: 1px solid rgba(16, 185, 129, 0.3); backdrop-filter: blur(4px); }
    .vt-hero h1 { font-size: clamp(3rem, 5vw, 4.5rem); font-weight: 800; margin: 0 0 24px 0; line-height: 1.1; letter-spacing: -1px; }
    .vt-hero p { font-size: clamp(1.1rem, 2vw, 1.5rem); color: #d6d3d1; margin: 0 auto 40px auto; font-weight: 300; max-width: 700px; line-height: 1.6; }
    
    /* Botones */
    .vt-btn-primary { display: inline-flex; align-items: center; justify-content: center; gap: 12px; background: #059669; color: white; padding: 18px 40px; border-radius: 50px; font-weight: bold; text-decoration: none; border: none; cursor: pointer; transition: all 0.3s ease; font-size: 1.125rem; box-shadow: 0 0 20px rgba(5, 150, 105, 0.4); }
    .vt-btn-primary:hover { background: #047857; transform: translateY(-3px); box-shadow: 0 0 30px rgba(5, 150, 105, 0.6); }
    .vt-btn-block { width: 100%; border-radius: 12px; padding: 16px; margin-top: 16px; }

    .vt-container { max-width: 1280px; margin: 0 auto; padding: 0 24px; position: relative; z-index: 20; }
    
    /* Stats */
    .vt-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; margin-top: -80px; margin-bottom: 80px; }
    @media(max-width: 768px) { .vt-stats-grid { grid-template-columns: repeat(2, 1fr); margin-top: -40px; } }
    .vt-stat-card { background: white; padding: 32px 24px; border-radius: 20px; box-shadow: 0 10px 40px rgba(0,0,0,0.08); text-align: center; border: 1px solid #f5f5f4; transition: transform 0.3s ease; }
    .vt-stat-card:hover { transform: translateY(-8px); }
    .vt-stat-num { font-size: 2.25rem; font-weight: 900; color: #059669; margin-bottom: 8px; }
    .vt-stat-label { font-size: 0.8rem; font-weight: 800; color: #78716c; text-transform: uppercase; letter-spacing: 0.5px; }

    /* Benefits Section */
    .vt-benefits { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; margin-bottom: 120px; padding: 40px 0; }
    @media(max-width: 992px) { .vt-benefits { grid-template-columns: 1fr; gap: 40px; } }
    .vt-benefits-img-wrapper { position: relative; }
    .vt-benefits-img-bg { position: absolute; inset: 0; background: #059669; border-radius: 24px; transform: rotate(-3deg) translate(8px, 8px); opacity: 0.1; }
    .vt-benefits-img { width: 100%; height: 600px; object-fit: cover; border-radius: 24px; position: relative; box-shadow: 0 25px 50px rgba(0,0,0,0.15); }
    .vt-benefits-content h2 { font-size: 3rem; margin-top: 0; margin-bottom: 24px; color: #1c1917; line-height: 1.1; }
    .vt-benefits-content h2 span { color: #059669; display: block;}
    .vt-benefits-content p { font-size: 1.125rem; color: #57534e; margin-bottom: 40px; line-height: 1.7; }
    .vt-benefit-item { display: flex; align-items: flex-start; gap: 16px; background: white; padding: 16px 20px; border-radius: 16px; margin-bottom: 16px; box-shadow: 0 2px 10px rgba(0,0,0,0.02); border: 1px solid #f5f5f4; }
    .vt-benefit-item svg { color: #10b981; flex-shrink: 0; margin-top: 2px; }
    .vt-benefit-item span { font-weight: 600; color: #44403c; }

    /* Varieties Section */
    .vt-varieties-section { background: #f5f5f4; padding: 100px 0; border-top: 1px solid #e7e5e4; border-bottom: 1px solid #e7e5e4; }
    .vt-section-title { text-align: center; margin-bottom: 64px; }
    .vt-section-title h2 { font-size: 2.5rem; color: #1c1917; margin-top: 0; margin-bottom: 16px; font-weight: bold; }
    .vt-section-title p { font-size: 1.25rem; color: #57534e; max-width: 700px; margin: 0 auto; }
    
    .vt-empty-state { background: white; padding: 48px; border-radius: 24px; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.05); border: 1px solid #e7e5e4; }
    .vt-empty-icon { width: 80px; height: 80px; background: #f5f5f4; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px auto; color: #a8a29e; }
    .vt-empty-state p { font-size: 1.25rem; color: #57534e; margin-bottom: 32px; font-weight: 500; }
    
    .vt-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); gap: 32px; }
    .vt-card { background: white; border-radius: 24px; padding: 32px; box-shadow: 0 10px 30px rgba(0,0,0,0.06); transition: all 0.3s ease; cursor: pointer; border: 2px solid transparent; position: relative; overflow: hidden; }
    .vt-card:hover { border-color: #a7f3d0; box-shadow: 0 20px 40px rgba(0,0,0,0.08); }
    .vt-card.selected { border-color: #10b981; box-shadow: 0 20px 40px rgba(16, 185, 129, 0.2); transform: scale(1.02); z-index: 2; }
    .vt-card-corner { position: absolute; top: 0; right: 0; width: 120px; height: 120px; background: #ecfdf5; border-bottom-left-radius: 100%; transition: transform 0.5s ease; z-index: 0; }
    .vt-card:hover .vt-card-corner { transform: scale(1.2); }
    .vt-card.selected .vt-card-corner { background: #d1fae5; transform: scale(1.5); }
    .vt-card-content { position: relative; z-index: 10; }
    .vt-card-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; }
    .vt-card h3 { font-size: 1.75rem; font-weight: bold; color: #1c1917; margin: 0; line-height: 1.2; }
    .vt-check-icon { background: #10b981; color: white; border-radius: 50%; padding: 4px; display: flex; }
    
    .vt-card-info { margin-bottom: 32px; }
    .vt-info-row { display: flex; align-items: center; gap: 16px; background: #fafaf9; padding: 12px 16px; border-radius: 12px; margin-bottom: 12px; }
    .vt-info-row svg { color: #059669; }
    .vt-info-text { display: flex; flex-direction: column; }
    .vt-info-label { font-size: 0.75rem; text-transform: uppercase; font-weight: bold; color: #78716c; margin-bottom: 2px; }
    .vt-info-value { font-weight: 600; color: #292524; font-size: 1rem; }
    .vt-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 16px; }
    .vt-info-mini { display: flex; align-items: center; gap: 12px; }
    .vt-info-mini svg { color: #a8a29e; }
    .vt-info-mini span { font-size: 0.875rem; font-weight: 500; color: #57534e; }
    
    .vt-btn-outline { width: 100%; display: flex; justify-content: center; align-items: center; gap: 8px; padding: 16px; border-radius: 12px; font-weight: bold; font-size: 1rem; border: none; cursor: pointer; transition: all 0.3s; background: #f5f5f4; color: #44403c; }
    .vt-btn-outline:hover { background: #e7e5e4; }
    .vt-card.selected .vt-btn-outline { background: #059669; color: white; box-shadow: 0 10px 20px rgba(5, 150, 105, 0.2); }

    /* Steps Section */
    .vt-steps-section { padding: 100px 0; }
    .vt-steps-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 32px; position: relative; }
    @media(max-width: 768px) { .vt-steps-grid { grid-template-columns: 1fr; gap: 24px; } }
    .vt-steps-line { position: absolute; top: 40px; left: 10%; right: 10%; height: 2px; background: #e7e5e4; z-index: 1; }
    @media(max-width: 768px) { .vt-steps-line { display: none; } }
    .vt-step { position: relative; z-index: 10; display: flex; flex-direction: column; align-items: center; text-align: center; }
    @media(max-width: 768px) { .vt-step { background: white; padding: 24px; border-radius: 16px; flex-direction: row; text-align: left; gap: 20px; box-shadow: 0 4px 10px rgba(0,0,0,0.03); } }
    .vt-step-num { width: 80px; height: 80px; min-width: 80px; background: #d1fae5; color: #047857; font-size: 1.5rem; font-weight: 900; display: flex; align-items: center; justify-content: center; border-radius: 50%; border: 4px solid white; box-shadow: 0 10px 20px rgba(0,0,0,0.08); margin-bottom: 24px; transition: transform 0.3s ease; }
    @media(max-width: 768px) { .vt-step-num { margin-bottom: 0; } }
    .vt-step:hover .vt-step-num { transform: scale(1.1); }
    .vt-step.active .vt-step-num { background: #059669; color: white; }
    .vt-step h4 { font-size: 1.25rem; color: #1c1917; margin: 0 0 8px 0; }
    .vt-step p { color: #57534e; margin: 0; font-weight: 500; font-size: 0.95rem; }

    /* Form Section */
    .vt-form-section { background: #1c1917; padding: 100px 0; }
    .vt-form-layout { display: grid; grid-template-columns: 5fr 7fr; gap: 64px; }
    @media(max-width: 992px) { .vt-form-layout { grid-template-columns: 1fr; } }
    
    .vt-contact-info-title { color: #34d399; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; font-size: 0.875rem; margin-bottom: 16px; display: block; }
    .vt-contact-info h2 { font-size: 3rem; color: white; margin: 0 0 24px 0; line-height: 1.1; }
    .vt-contact-info p { color: #a8a29e; font-size: 1.125rem; line-height: 1.7; margin-bottom: 48px; }
    
    .vt-contact-card { display: flex; align-items: center; gap: 24px; background: rgba(255,255,255,0.03); padding: 24px; border-radius: 20px; border: 1px solid rgba(255,255,255,0.08); margin-bottom: 24px; cursor: pointer; transition: all 0.3s; }
    .vt-contact-card:hover { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.2); }
    .vt-contact-icon { width: 64px; height: 64px; background: rgba(16, 185, 129, 0.2); color: #34d399; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all 0.3s; }
    .vt-contact-card:hover .vt-contact-icon { background: #10b981; color: white; }
    .vt-contact-card h4 { margin: 0 0 4px 0; color: #a8a29e; font-size: 1rem; font-weight: 500; }
    .vt-contact-card span { display: block; font-size: 1.5rem; font-weight: bold; color: white; }
    
    .vt-form-box { background: white; border-radius: 32px; padding: 48px; box-shadow: 0 25px 50px rgba(0,0,0,0.2); }
    @media(max-width: 600px) { .vt-form-box { padding: 32px 24px; border-radius: 24px; } }
    .vt-form-box h3 { margin-top: 0; margin-bottom: 32px; font-size: 1.75rem; color: #1c1917; font-weight: bold; }
    
    .vt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 24px; }
    .vt-form-grid-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 24px; margin-bottom: 24px; }
    @media(max-width: 600px) { .vt-form-grid, .vt-form-grid-3 { grid-template-columns: 1fr; } }
    
    .vt-input-group { display: flex; flex-direction: column; gap: 8px; margin-bottom: 24px; }
    .vt-form-grid .vt-input-group, .vt-form-grid-3 .vt-input-group { margin-bottom: 0; }
    .vt-input-group label { font-size: 0.875rem; font-weight: 700; color: #44403c; }
    .vt-input { padding: 16px 20px; border-radius: 12px; border: 2px solid #f5f5f4; background: #fafaf9; font-size: 1rem; font-family: inherit; font-weight: 500; color: #1c1917; transition: all 0.3s; width: 100%; box-sizing: border-box; appearance: none; }
    .vt-input:focus { outline: none; border-color: #10b981; background: white; box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1); }
    .vt-input::placeholder { color: #a8a29e; font-weight: 400; }
    select.vt-input { cursor: pointer; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23a8a29e' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 16px center; background-size: 16px; padding-right: 48px; }
    textarea.vt-input { resize: vertical; min-height: 120px; }

    /* FAQ Section */
    .vt-faq-section { padding: 100px 0; max-width: 900px; margin: 0 auto; }
    .vt-faq-title { text-align: center; font-size: 2.5rem; color: #1c1917; margin-bottom: 64px; }
    .vt-faq-list { display: flex; flex-direction: column; gap: 24px; }
    .vt-faq-item { background: white; padding: 32px; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.03); border: 1px solid #f5f5f4; transition: box-shadow 0.3s; }
    .vt-faq-item:hover { box-shadow: 0 10px 30px rgba(0,0,0,0.08); }
    .vt-faq-header { display: flex; align-items: flex-start; gap: 16px; margin-bottom: 16px; }
    .vt-faq-icon { background: #d1fae5; color: #059669; padding: 8px; border-radius: 10px; display: flex; margin-top: 2px; }
    .vt-faq-item h4 { font-size: 1.25rem; margin: 0; color: #1c1917; line-height: 1.4; }
    .vt-faq-item p { margin: 0 0 0 52px; color: #57534e; line-height: 1.6; font-size: 1.05rem; }
    @media(max-width: 600px) { .vt-faq-item p { margin-left: 0; margin-top: 16px; } }
  `;

  if (loading) {
    return (
      <div className="vt-wrapper">
        <style>{internalStyles}</style>
        <div className="vt-loader">
          <div className="vt-spinner"></div>
          <p>Cargando orígenes excepcionales...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="vt-wrapper">
      <style>{internalStyles}</style>
      <SEO 
        title="Café Verde | Venta por Kilo y Tonelada | Román Valderrábano El Catador"
        description="Venta de café verde para tostadores, importadores y productores. Compra desde 1 kg hasta toneladas."
        keywords="café verde, café por kilo, café por tonelada, exportación café mexicano"
        url="https://romanvalderrabanoelcatador.com/venta-tonelada"
      />
      
      {/* Modal de Éxito */}
      {showModal && (
        <div className="vt-modal-overlay">
          <div className="vt-modal">
            <button onClick={() => setShowModal(false)} className="vt-modal-close">
              <X size={24} />
            </button>
            <div className="vt-modal-icon">
              <CheckCircle2 size={40} />
            </div>
            <h3>¡Solicitud Enviada!</h3>
            <p>{modalMessage}</p>
            <button onClick={() => setShowModal(false)} className="vt-btn-primary vt-btn-block">
              Entendido
            </button>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="vt-hero">
        <img 
          src="https://images.unsplash.com/photo-1559525839-b184a4d698c7?auto=format&fit=crop&q=80" 
          alt="Café verde" 
          className="vt-hero-img"
        />
        <div className="vt-hero-overlay"></div>
        <div className="vt-hero-content">
          <span className="vt-badge">Exportación Directa</span>
          <h1>Café Verde de Especialidad</h1>
          <p>
            Selección premium para tostadores e importadores. 
            Venta desde 1 kg hasta contenedores completos.
          </p>
          <a href="#catalogo" className="vt-btn-primary">
            Ver Catálogo de Orígenes
          </a>
        </div>
      </section>

      {/* Stats Section */}
      <div className="vt-container">
        <div className="vt-stats-grid">
          {[
            { num: '1000+', label: 'Toneladas exportadas' },
            { num: '15+', label: 'Países importadores' },
            { num: '100%', label: 'Trazabilidad' },
            { num: '5', label: 'Certificaciones' }
          ].map((stat, i) => (
            <div key={i} className="vt-stat-card">
              <div className="vt-stat-num">{stat.num}</div>
              <div className="vt-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits Section */}
      <section className="vt-container">
        <div className="vt-benefits">
          <div className="vt-benefits-img-wrapper">
            <div className="vt-benefits-img-bg"></div>
            <img 
              src="https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&q=80" 
              alt="Café verde en costales"
              className="vt-benefits-img"
            />
          </div>
          
          <div className="vt-benefits-content">
            <h2>De nuestra finca <br/><span>a tu tostador.</span></h2>
            <p>
              En Román Valderrábano El Catador, eliminamos los intermediarios para ofrecerte el mejor café 
              verde del mercado. Trabajamos mano a mano con tostadores y productores, asegurando calidad desde el cultivo.
            </p>
            
            <div className="vt-benefits-list">
              {[
                'Precios competitivos - Hasta 30% menos que el mercado',
                'Trazabilidad completa con certificados de origen',
                'Perfiles de taza certificados por Q-Graders',
                'Documentación de exportación incluida',
                'Flexibilidad en volúmenes: desde 1 kg hasta toneladas',
                'Envíos garantizados a cualquier parte del mundo'
              ].map((benefit, idx) => (
                <div key={idx} className="vt-benefit-item">
                  <CheckCircle2 size={24} />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Variedades Disponibles */}
      <section id="catalogo" className="vt-varieties-section">
        <div className="vt-container">
          <div className="vt-section-title">
            <h2>Variedades de Origen</h2>
            <p>Seleccionamos los mejores granos para garantizar una taza excepcional en tu tostaduría.</p>
          </div>
          
          {varieties.length === 0 ? (
            <div className="vt-empty-state">
              <div className="vt-empty-icon">
                <Coffee size={36} />
              </div>
              <p>Actualizando nuestro catálogo de variedades...</p>
              <button 
                className="vt-btn-primary"
                onClick={() => openWhatsApp({ name: 'catálogo general' })}
              >
                <MessageCircle size={24} />
                Consultar Disponibilidad por WhatsApp
              </button>
            </div>
          ) : (
            <div className="vt-grid">
              {varieties.map(variety => (
                <div 
                  key={variety.id} 
                  className={`vt-card ${selectedVariety === variety.id ? 'selected' : ''}`}
                  onClick={() => {
                    setSelectedVariety(variety.id);
                    setFormData(prev => ({ ...prev, quality: variety.name }));
                    document.getElementById('formulario-cotizacion')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <div className="vt-card-corner"></div>
                  
                  <div className="vt-card-content">
                    <div className="vt-card-header">
                      <h3>{variety.name}</h3>
                      {selectedVariety === variety.id && (
                        <span className="vt-check-icon">
                          <CheckCircle2 size={20} />
                        </span>
                      )}
                    </div>
                    
                    <div className="vt-card-info">
                      <div className="vt-info-row">
                        <MapPin size={24} />
                        <div className="vt-info-text">
                          <span className="vt-info-label">Origen</span>
                          <span className="vt-info-value">{variety.origin}</span>
                        </div>
                      </div>
                      
                      <div className="vt-info-row">
                        <Coffee size={24} />
                        <div className="vt-info-text">
                          <span className="vt-info-label">Perfil de Taza</span>
                          <span className="vt-info-value">{variety.profile}</span>
                        </div>
                      </div>

                      <div className="vt-info-grid">
                        <div className="vt-info-mini">
                          <Mountain size={18} />
                          <span>{variety.altitude}</span>
                        </div>
                        <div className="vt-info-mini">
                          <Droplets size={18} />
                          <span>{variety.humedad}</span>
                        </div>
                        <div className="vt-info-mini" style={{ gridColumn: 'span 2' }}>
                          <Leaf size={18} />
                          <span>{variety.especie}</span>
                        </div>
                      </div>
                    </div>

                    <button 
                      className="vt-btn-outline"
                      onClick={(e) => {
                        e.stopPropagation();
                        openWhatsApp(variety);
                      }}
                    >
                      <MessageCircle size={20} />
                      Consultar Vía WhatsApp
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Proceso de Compra */}
      <section className="vt-steps-section vt-container">
        <div className="vt-section-title">
          <h2>Tu Café en 5 Pasos</h2>
          <p>Un proceso transparente y eficiente, sin importar en qué parte del mundo estés.</p>
        </div>
        
        <div className="vt-steps-grid">
          <div className="vt-steps-line"></div>
          
          {[
            { title: 'Contacto', desc: 'Déjanos tus datos y requerimientos.' },
            { title: 'Asesoría', desc: 'Buscamos el perfil ideal para ti.' },
            { title: 'Muestras', desc: 'Te enviamos muestras de 1kg.' },
            { title: 'Cotización', desc: 'Propuesta final con envío.' },
            { title: 'Logística', desc: 'Documentación y embarque.' }
          ].map((step, idx) => (
            <div key={idx} className={`vt-step ${idx === 0 ? 'active' : ''}`}>
              <div className="vt-step-num">{idx + 1}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Contacto & Formulario */}
      <section id="formulario-cotizacion" className="vt-form-section">
        <div className="vt-container vt-form-layout">
          
          <div className="vt-contact-info">
            <span className="vt-contact-info-title">Hablemos de negocios</span>
            <h2>Solicita tu Cotización Exacta</h2>
            <p>
              Nuestros asesores comerciales están listos para enviarte precios, disponibilidad y costos logísticos. Te responderemos en menos de 24 horas.
            </p>
            
            <div className="vt-contact-card" onClick={() => openWhatsApp({ name: 'cotización general' })}>
              <div className="vt-contact-icon">
                <Phone size={28} />
              </div>
              <div>
                <h4>WhatsApp Comercial</h4>
                <span>+52 764 105 7461</span>
              </div>
            </div>
            
            <div className="vt-contact-card">
              <div className="vt-contact-icon">
                <Mail size={28} />
              </div>
              <div>
                <h4>Correo Electrónico</h4>
                <span>ventas@cafeelcatador.com</span>
              </div>
            </div>
          </div>

          <div className="vt-form-box">
            <h3>Detalles de tu requerimiento</h3>
            
            <form onSubmit={handleSubmit}>
              <div className="vt-form-grid">
                <div className="vt-input-group">
                  <label>Nombre Completo *</label>
                  <input type="text" name="name" value={formData.name} onChange={handleInputChange} required className="vt-input" placeholder="Ej. Juan Pérez" />
                </div>
                <div className="vt-input-group">
                  <label>Empresa</label>
                  <input type="text" name="company" value={formData.company} onChange={handleInputChange} className="vt-input" placeholder="Tu tostaduría" />
                </div>
              </div>

              <div className="vt-form-grid">
                <div className="vt-input-group">
                  <label>Email *</label>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} required className="vt-input" placeholder="correo@empresa.com" />
                </div>
                <div className="vt-input-group">
                  <label>Teléfono *</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required className="vt-input" placeholder="+52 ..." />
                </div>
              </div>

              <div className="vt-form-grid-3">
                <div className="vt-input-group">
                  <label>País *</label>
                  <input type="text" name="country" value={formData.country} onChange={handleInputChange} required className="vt-input" placeholder="Ej. España" />
                </div>
                <div className="vt-input-group">
                  <label>Cantidad *</label>
                  <input type="number" name="quantity" value={formData.quantity} onChange={handleInputChange} min="1" step="0.1" required className="vt-input" />
                </div>
                <div className="vt-input-group">
                  <label>Unidad *</label>
                  <select name="quantityUnit" value={formData.quantityUnit} onChange={handleInputChange} className="vt-input">
                    <option value="kg">Kilos (kg)</option>
                    <option value="ton">Toneladas</option>
                  </select>
                </div>
              </div>

              <div className="vt-input-group" style={{ marginBottom: '24px' }}>
                <label>Variedad de Interés *</label>
                <select name="quality" value={formData.quality} onChange={handleInputChange} required className="vt-input">
                  <option value="" disabled>Selecciona una variedad del catálogo...</option>
                  {varieties.map(v => (
                    <option key={v.id} value={v.name}>{v.name}</option>
                  ))}
                  <option value="Otra/No estoy seguro">Necesito asesoría u otra variedad</option>
                </select>
              </div>

              <div className="vt-input-group">
                <label>Mensaje Adicional</label>
                <textarea name="message" value={formData.message} onChange={handleInputChange} className="vt-input" placeholder="Destino final, tipo de empaque (GrainPro, Yute), etc..."></textarea>
              </div>

              <button type="submit" className="vt-btn-submit">
                Enviar Solicitud
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="vt-faq-section vt-container">
        <h2 className="vt-faq-title">Preguntas Frecuentes</h2>
        
        <div className="vt-faq-list">
          {[
            { q: '¿Cuál es el volumen mínimo de compra?', a: 'No tenemos volumen mínimo para venta nacional. Puedes comprar desde 1 kilogramo hasta toneladas. Para exportación, sugerimos un mínimo de 100kg para optimizar costos de envío.' },
            { q: '¿Incluyen los costos de envío?', a: 'Los precios de nuestro catálogo son EXW (Ex Works). Los costos de envío o exportación se cotizan por separado según el destino, volumen y el Incoterm acordado.' },
            { q: '¿Puedo recibir muestras antes de comprar?', a: 'Sí, enviamos muestras de 1kg (verde o tostado) de cualquier variedad disponible. Solo cubres el costo de envío y la muestra, el cual se reembolsa en tu primera compra mayor a 50kg.' },
            { q: '¿Qué documentación proporcionan para exportación?', a: 'Proveemos certificados de origen, análisis de taza emitido por Q-Graders, certificado fitosanitario, factura comercial y packing list (lista de empaque).' }
          ].map((faq, idx) => (
            <div key={idx} className="vt-faq-item">
              <div className="vt-faq-header">
                <div className="vt-faq-icon"><MessageSquare size={20} /></div>
                <h4>{faq.q}</h4>
              </div>
              <p>{faq.a}</p>
            </div>
          ))}
        </div>
      </section>
      
    </div>
  );
};

export default VentaTonelada;